import React, { useEffect, useState } from "react";
import MainContainer from "../../container/MainContainer";
import Notification from "./Notification";
import Termsofservice from "./Termsofservice";
import { Tab, Nav } from "react-bootstrap";
// import Referrals from "./Referrals";
import { useParams, useHistory } from "react-router-dom";

const SettingsLayout = () => {
  const params = useParams();
  const history = useHistory();

  const [eventKey, setEventKey] = useState("notifications");

  useEffect(() => {
    if (params && params.id) {
      setEventKey(params.id);
    } else {
      setEventKey("notifications");
    }
  }, []);

  return (
    <MainContainer active="settings">
      <section className="settings-section">
        <div className="title">
          <h1>Settings</h1>
        </div>
        <div className="tab-cover">
          <Tab.Container
            id="left-tabs-example"
            defaultActiveKey={"notifications"}
          >
            <Nav variant="pills" className="tabs-list">
              <Nav.Item
                onClick={() => {
                  setEventKey("notifications");
                  history.push("/settings/notifications");
                }}
              >
                <Nav.Link
                  eventKey={"notifications"}
                  active={eventKey === "notifications"}
                >
                  <span className="tab-name">Notifications</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item
                onClick={() => {
                  setEventKey("terms_of_services");
                  history.push("/settings/terms_of_services");
                }}
              >
                <Nav.Link
                  eventKey={"terms_of_services"}
                  active={eventKey === "terms_of_services"}
                >
                  <span className="tab-name">Terms of Services</span>
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item
                onClick={() => {
                  setEventKey("referrals");
                  history.push("/settings/referrals");
                }}
              >
                <Nav.Link
                  eventKey={"referrals"}
                  active={eventKey === "referrals"}
                >
                  <span className="tab-name">Referrals</span>
                </Nav.Link>
              </Nav.Item> */}
            </Nav>
            <Tab.Content>
              <Tab.Pane
                eventKey={"notifications"}
                active={eventKey === "notifications"}
              >
                <Notification />
              </Tab.Pane>
              <Tab.Pane
                eventKey={"terms_of_services"}
                active={eventKey === "terms_of_services"}
              >
                <Termsofservice />
              </Tab.Pane>
              {/* <Tab.Pane
                eventKey={"referrals"}
                active={eventKey === "referrals"}
              >
                <Referrals />
              </Tab.Pane> */}
            </Tab.Content>
          </Tab.Container>
        </div>
      </section>
    </MainContainer>
  );
};

export default SettingsLayout;
